/* eslint-disable */
import { B, SecLabel, Btn, useReveal } from "../shared";
import { articles } from "../content/articles";

const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }); }
  catch (e) { return iso; }
};

// ─── INSIGHTS INDEX ─────────────────────────────────────────────────────────────
function InsightsIndex({ setPage, onOpenArticle }) {
  const [gridRef, gridReveal] = useReveal();

  return (
    <>
      {/* HERO */}
      <section style={{ background: `linear-gradient(135deg,${B.navyD},${B.navyM})`, padding: "56px 48px", position: "relative", overflow: "hidden" }}>
        <div aria-hidden="true" style={{ position: "absolute", top: "-100px", right: "-40px", width: 340, height: 340, borderRadius: "50%", background: B.blueL, opacity: 0.32, filter: "blur(70px)", zIndex: 0, pointerEvents: "none" }} />
        <div aria-hidden="true" style={{ position: "absolute", top: "60px", right: "220px", width: 260, height: 260, borderRadius: "50%", background: B.blue, opacity: 0.3, filter: "blur(70px)", zIndex: 0, pointerEvents: "none" }} />
        <div style={{ maxWidth: 1100, margin: "0 auto", position: "relative", zIndex: 1 }}>
          <SecLabel><span style={{ color: "#90CAF9" }}>Commercial Intelligence</span></SecLabel>
          <h1 className="jk hero-h1" style={{ fontWeight: 800, letterSpacing: "-0.03em", color: "white", marginBottom: 14, lineHeight: 1.1 }}>Guides, research and commercial thinking.</h1>
          <p style={{ fontSize: 15, color: "rgba(255,255,255,0.7)", fontWeight: 300, lineHeight: 1.78, maxWidth: 560 }}>Practical thinking for ambitious UK businesses — market signals, lending trends and structured guidance for funding decisions.</p>
        </div>
      </section>

      {/* ARTICLE GRID */}
      <section ref={gridRef} style={{ maxWidth: 1100, margin: "0 auto", padding: "56px 48px", ...gridReveal }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16 }}>
          {articles.map((a) => (
            <button key={a.slug} onClick={() => onOpenArticle(a.slug)} style={{ background: "white", border: `1px solid ${B.border}`, borderRadius: 14, padding: "24px 22px", textAlign: "left", cursor: "pointer", transition: "transform .2s, box-shadow .2s" }}
              onMouseEnter={(e) => { e.currentTarget.style.boxShadow = `0 24px 48px ${B.navy}1a`; e.currentTarget.style.transform = "translateY(-6px)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "translateY(0)"; }}>
              <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 10 }}>
                <span className="mono" style={{ color: B.blue }}>{a.category}</span>
                <span style={{ color: B.border }}>·</span>
                <span className="mono" style={{ color: B.inkF }}>{a.readingTime}</span>
              </div>
              <h3 className="jk" style={{ fontSize: 16, fontWeight: 700, color: B.navy, marginBottom: 8, lineHeight: 1.3 }}>{a.title}</h3>
              <p style={{ fontSize: 11, color: B.inkM, lineHeight: 1.65, fontWeight: 300, marginBottom: 12 }}>{a.description}</p>
              <p style={{ fontSize: 9, color: B.inkF, fontWeight: 500 }}>{fmtDate(a.date)} · {a.author}</p>
            </button>
          ))}
        </div>
      </section>
    </>
  );
}

// ─── ARTICLE PAGE ─────────────────────────────────────────────────────────────
function ArticlePage({ slug, setPage }) {
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <div style={{ maxWidth: 600, margin: "80px auto", padding: "0 48px", textAlign: "center" }}>
        <h1 className="jk" style={{ fontSize: 24, fontWeight: 700, color: B.navy, marginBottom: 9 }}>Article not found.</h1>
        <p style={{ fontSize: 13, color: B.inkM, fontWeight: 300, lineHeight: 1.7, marginBottom: 22 }}>The article you're looking for doesn't exist or may have been moved.</p>
        <Btn size="md" onClick={() => setPage("insights")} style={{ borderRadius: 8 }}>← Back to Commercial Intelligence</Btn>
      </div>
    );
  }

  return (
    <section style={{ maxWidth: 760, margin: "0 auto", padding: "48px 48px 64px" }}>
      <button onClick={() => setPage("insights")} style={{ background: "none", border: "none", color: B.inkM, fontSize: 11, cursor: "pointer", marginBottom: 22, display: "flex", alignItems: "center", gap: 5, padding: 0 }}>← All articles</button>
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 14 }}>
        <span className="mono" style={{ color: B.blue }}>{article.category}</span>
        <span style={{ color: B.border }}>·</span>
        <span className="mono" style={{ color: B.inkF }}>{article.readingTime}</span>
      </div>
      <h1 className="jk hero-h1" style={{ fontWeight: 800, letterSpacing: "-0.03em", color: B.navy, marginBottom: 12, lineHeight: 1.1 }}>{article.title}</h1>
      <p style={{ fontSize: 11, color: B.inkF, marginBottom: 28, fontWeight: 500 }}>{fmtDate(article.date)} · {article.author}</p>
      <div className="jk-body" style={{ fontSize: 15, color: B.inkS, lineHeight: 1.85, fontWeight: 300 }} dangerouslySetInnerHTML={{ __html: article.body }} />
      {article.tags?.length > 0 && (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 28, paddingTop: 22, borderTop: `1px solid ${B.border}` }}>
          {article.tags.map((t) => <span key={t} style={{ fontSize: 9, color: B.inkM, background: B.light, borderRadius: 100, padding: "4px 10px", fontWeight: 600 }}>{t}</span>)}
        </div>
      )}
      <div style={{ marginTop: 32, background: `linear-gradient(135deg,${B.navy},${B.navyM})`, borderRadius: 14, padding: "22px 24px" }}>
        <h3 className="jk" style={{ fontSize: 14, fontWeight: 700, color: "white", marginBottom: 8 }}>Want to talk this through?</h3>
        <p style={{ fontSize: 11, color: "rgba(255,255,255,0.6)", lineHeight: 1.65, fontWeight: 300, marginBottom: 14 }}>A Capital Review is a focused, no-obligation conversation about your specific commercial position.</p>
        <Btn v="white" size="sm" onClick={() => setPage("contact")} style={{ borderRadius: 7 }}>Book a Capital Review</Btn>
      </div>
    </section>
  );
}

export { InsightsIndex, ArticlePage };
